import { render, staticRenderFns } from "./TripSettingsNav.vue?vue&type=template&id=3d594454"
import script from "./TripSettingsNav.vue?vue&type=script&lang=js"
export * from "./TripSettingsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports